var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset"},[_c('password-reset-form',{attrs:{"title":"Password Reset Form","status-message":_vm.updateMessage},on:{"save":function($event){return _vm.handlePasswordChange($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }